import React from 'react';
import { getClothIcon } from '../clothIcons';
import { GenderSetting, getClothTypesForGender } from '../config/clothTypes';

interface GarmentTypeStepProps {
  gender: GenderSetting;
  clothType: string;
  onSelect: (clothType: string) => void;
}

const GarmentTypeStep: React.FC<GarmentTypeStepProps> = ({ gender, clothType, onSelect }) => {
  const clothTypes = getClothTypesForGender(gender);

  return (
    <div className="mx-auto w-full max-w-6xl py-2">
      <div className="rounded-2xl border border-gray-200 bg-gray-50/50 p-6 shadow-sm">
        <h4 className="text-sm font-bold uppercase tracking-wider text-gray-700">Garment Type</h4>
        <p className="mb-5 mt-1 text-sm text-gray-500">
          Choose the type of clothing in your uploaded image.
        </p>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {clothTypes.map((type) => {
            const isSelected = clothType === type.id;
            return (
              <button
                key={type.id}
                type="button"
                onClick={() => onSelect(type.id)}
                className={`relative flex flex-col items-center rounded-2xl border-2 p-4 text-center transition-all duration-300 ${
                  isSelected
                    ? 'border-secondary-500 bg-white shadow-md'
                    : 'border-gray-200 bg-white hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-sm'
                }`}
              >
                <span className="text-3xl">{getClothIcon(type.id)}</span>
                <span className="mt-2 text-xs font-semibold text-gray-900">{type.name}</span>
                <span className="mt-0.5 text-[10px] text-gray-400">{type.category}</span>
                {isSelected && (
                  <span className="absolute right-2 top-2 rounded-full bg-secondary-500 p-1 text-white">
                    <i className="fas fa-check text-[9px]" />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GarmentTypeStep;
